import { Link, useNavigate } from 'react-router-dom'
import styles from '../../../pages/Account/ExhibitorSetup/ExhibitorSetup.module.css'
import * as accountService from '../../../services/accountService'
import * as homeService from '../../../services/homeService'
const ExhibitorItem = ({ index, exhibitor, user }) => {    
    const navigate = useNavigate()
    const handleActivate = async e => {
        e.preventDefault()
        await accountService.activate(exhibitor.id);
    }
    const handleDeactivate = async e => {
        e.preventDefault()
        await accountService.deactivate(exhibitor.id);
    }
    const handleInvite = async e => {
        e.preventDefault()
        await homeService.sendDetails(exhibitor.id);
    }
    const createRequestBody = async () => {

        let requestBody = {}
        requestBody =
        {
            "userName": `${exhibitor.userName}`,
            "overrideUserName": `${user.email}`,
        }
        return await requestBody;
    }
    const handleImpersonate = async e => {
        e.preventDefault()
        const getReqBody = await createRequestBody()
        await accountService.impersonate(getReqBody);
        // force refresh and navigate to index
        //window.location.reload();
        //navigate('/index')
        window.location.href = '/index'
    }
    return (
        <>
            <tr className={styles.trChilds} key={index}>
                <td className={styles.tdChilds}>{exhibitor.firstName} {exhibitor.lastName} ({exhibitor.userName})</td>
                <td className={styles.tdChilds}> {exhibitor.roleName}</td>
                <td className={styles.tdChilds}> {exhibitor.eventRefs}</td>
                <td className={styles.tdChilds}> {exhibitor.accountRefs}</td>
                <td className={styles.tdChilds}> {exhibitor.parent}</td>
                <td className={styles.tdChilds}> {exhibitor.isDeleted && exhibitor.isDeleted === true ?
                    <Link onClick={e => handleActivate(e)} className={styles.button}>Activate</Link>
                    :
                    <Link onClick={e => handleDeactivate(e)} className={styles.button}>Deactivate</Link>}
                </td>        
                <td className={styles.tdChilds}>
                    <Link onClick={e => handleInvite(e)} className={styles.button}>Send</Link>
                </td>       
                <td className={styles.tdChilds}>
                    <Link onClick={e => handleImpersonate(e)} className={styles.button}>Impersonate</Link>
                </td>      
            </tr>
        </>
    );
}

export default ExhibitorItem;